import React from 'react';
import { Box, Button, Container, Flex, Icon, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { SectionHeading } from './SectionHeading';
import { brand, images, whatsappHref } from '../data/brand';
const channels = [{
  icon: WhatsAppIcon,
  label: 'WhatsApp',
  value: brand.whatsapp,
  href: whatsappHref(),
  external: true
}, {
  icon: PhoneIcon,
  label: 'Teléfono',
  value: brand.phone,
  href: brand.phoneHref,
  external: false
}, {
  icon: MailIcon,
  label: 'Correo',
  value: brand.email,
  href: brand.emailHref,
  external: false
}, {
  icon: MapPinIcon,
  label: 'Ubicación',
  value: 'Miami, Florida',
  href: undefined,
  external: false
}];
export function Contact() {
  return <Box as="section" id="contacto" position="relative" bg="plum.950" backgroundImage={`url(${images.altar})`} backgroundSize="cover" backgroundPosition="center" py={{
    base: 14,
    md: 24
  }} overflow="hidden" data-id="element-34" data-mp="ghnl9wz32xj6">
      <Box position="absolute" inset={0} bg="rgba(13,6,19,0.92)" aria-hidden="true" data-id="element-35" data-mp="3otmhkzeailur" />
      <Container maxW="66rem" px={{
      base: 4,
      md: 6
    }} position="relative" data-id="element-36" data-mp="3b3sr6cn4ztix">
        <SectionHeading eyebrow="Estamos para escucharte" title="CONSULTA CON NOSOTROS" description="Comunícate con nuestro equipo para conocer nuestros servicios y resolver tus preguntas." tone="dark" data-id="element-37" data-mp="3f4uup5o36rqp" />

        <SimpleGrid columns={{
        base: 1,
        sm: 2
      }} spacing={{
        base: 3,
        md: 4
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-38" data-mp="365rbm1ox6cc7">
          {channels.map(channel => {
          const content = <Flex align="center" gap={4} bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.200" borderRadius="lg" px={5} py={4} h="100%" transition="all 0.2s ease" _hover={channel.href ? {
            borderColor: 'gold.300',
            bg: 'whiteAlpha.100'
          } : undefined} data-id="element-39" data-mp="2w6a4rgxxlsen">
                <Flex align="center" justify="center" w="2.5rem" h="2.5rem" flexShrink={0} borderRadius="full" border="1px solid" borderColor="gold.400" color="gold.300" data-id="element-40" data-mp="1ua47msmwnt8l">
                  <Icon as={channel.icon} boxSize="1.1rem" aria-hidden="true" data-id="element-41" data-mp="2i2kx3o8z2nhx" />
                </Flex>
                <Box minW={0} data-id="element-42" data-mp="2d7f2m11i80i8">
                  <Text fontSize="0.68rem" letterSpacing="0.18em" textTransform="uppercase" color="gold.300" data-id="element-43" data-mp="28b6vnaxgndm5">
                    {channel.label}
                  </Text>
                  <Text fontSize={{
                base: 'sm',
                md: 'md'
              }} color="cream.50" wordBreak="break-word" data-id="element-44" data-mp="30xhry9e1asd5">
                    {channel.value}
                  </Text>
                </Box>
              </Flex>;
          return channel.href ? <Link key={channel.label} href={channel.href} isExternal={channel.external} _hover={{
            textDecoration: 'none'
          }} data-id="element-45" data-mp="3i7vgp3g4odxk">
                {content}
              </Link> : <Box key={channel.label} data-id="element-46" data-mp="2ifddeiwyj0">{content}</Box>;
        })}
        </SimpleGrid>

        <VStack spacing={4} mt={{
        base: 10,
        md: 12
      }} data-id="element-47" data-mp="4t8mav2ll9ft">
          <Stack direction={{
          base: 'column',
          sm: 'row'
        }} spacing={3} w={{
          base: '100%',
          sm: 'auto'
        }} data-id="element-48" data-mp="4vv4don477ca">
            <Button as="a" href={whatsappHref()} target="_blank" rel="noopener noreferrer" variant="whatsapp" size="lg" h={{
            base: '3.5rem',
            md: '3.75rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} w={{
            base: '100%',
            sm: 'auto'
          }} leftIcon={<WhatsAppIcon size={21} data-id="element-50" data-mp="ex5jixlw2hy7" />} data-id="element-49" data-mp="dv84vrt9glkv">
              ESCRIBIR POR WHATSAPP
            </Button>
            <Button as="a" href={brand.phoneHref} variant="goldSolid" size="lg" h={{
            base: '3.5rem',
            md: '3.75rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} w={{
            base: '100%',
            sm: 'auto'
          }} leftIcon={<PhoneIcon size={18} aria-hidden="true" data-id="element-52" data-mp="3scbm3uz9owgs" />} data-id="element-51" data-mp="9x9dytxjmigj">
              LLAMAR AHORA
            </Button>
          </Stack>
          <Text fontSize="sm" color="plum.200" textAlign="center" data-id="element-53" data-mp="3neii98lfsejo">
            Atendemos consultas de personas mayores de 18 años.
          </Text>
        </VStack>
      </Container>
    </Box>;
}